import React from 'react';

const NotFound = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center h-100">
      <div className="notFound" />
      <div className="fs-20 fw-600 margin-top-10">
        We are unable to find the page you are looking for
      </div>
      <span className="fs-12">
        Check the URL for any misspellings or{' '}
        <a href="/">
          <span>Back to home</span>
        </a>
      </span>
    </div>
  );
};

export default NotFound;
